export default __webpack_public_path__ + "static/media/transfer.36e920fa.svg";